import { memo, MutableRefObject, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { ProjectTy } from "../../../../ReduxTool/Slice/Auth/types";
import { generationdegradationwithfinance, generationdegradationwithfinance2 } from "../../../../ReduxTool/Slice/Consumer/ConsumerActions";
import { setFormQuickPlantAnalysisData, setFromProjectSummeryData, setPlantCapacity, setSelectedOption } from "../../../../ReduxTool/Slice/Consumer/ConsumerReducers";
import { FileUplad, ProjectSummaryType, quickplantAnalysisType } from "../../../../ReduxTool/Slice/Consumer/types";
import { useAppDispatch, useAppSelector } from "../../../../ReduxTool/store/hooks";
import globalLayers from "../../../../Utils/CustomerMaps/Maps/GlobaLMap";
import { fetchCountryNamefromLatLng } from "../../../../Utils/CustomerMaps/Maps/LazyloadMap";
import { getCurrencyLabel, convertACtoDC, currencyConverter, formatCompactMoney, formatCompactNumber, formatEnergy, formatEnergyGeneration, formatMoney, formatNumber2, getEstimateCacheKey, getEstimateInputs, toFixed } from "../../../../Utils/commonFunctions";
import { fetchModuleInverter } from "../../../../ReduxTool/Slice/Consumer/Api";
import { BackBoxIcon, InfoMark, SolarPowerIcon } from "../../../../assests/icons/Icons";
import { IconInfo1 } from "../../../../assests/icons/DrawerIcons";
import { CostBreakdownTooltip } from "../Proposal/Payment";
import { setModalHeaderFooter } from "../../../../ReduxTool/Slice/CommonReducers/CommonReducers";
import { Button } from "../../../../Components/AllButton/AllButtons.tsx";
import { InputRadio } from "../../../../Components/AllInput/AllInput";
import { StarRating } from "../ConfirmActionModal/ConfirmAction";
import { submitPvnxtRating } from "../../../../ReduxTool/Slice/CommonReducers/CommonActions";
import { defaultModuleObject } from "./Const";
import { IconClose } from "../../../../assests/icons/ModalIcons";
import { PVNXT_MODE } from "../../../../Utils/Const";

const SolarSummary = ({ isLoading, projectSetupUpdated, setIsLoading, setSiteAnalysisFailMsg, openViewProfileModal, isCompleted, saveProjectDetails }:
  { isLoading?: boolean, projectSetupUpdated: MutableRefObject<boolean>, setIsLoading?: (arg: boolean) => void, setSiteAnalysisFailMsg?: (arg: boolean) => void, openViewProfileModal?: (arg: any) => void, isCompleted: boolean, saveProjectDetails?: (projectid?: string, quickplantanalysis?: boolean) => Promise<void> }) => {
  const dispatch = useAppDispatch();
  const { user: { country_mstr } } = useAppSelector(state => state.auth);
  const { roofAnalysis: { selected_project, formDetails: { projectSummary, projectSetup: { lat, lng, electricityrate, sanctionload, plantcapacity, useablearea }, quickplantAnalysis } }, ondFiles } = useAppSelector((state) => state.consumerReducers);
  const { user } = useAppSelector(state => state.auth);
  const { roofAnalysis: { formDetails: { projectSetup } }, generationLoading } = useAppSelector((state) => state.consumerReducers);
  const { selectedOption, subsequentOption } = useAppSelector(state => state.consumerReducers.roofAnalysis)
  const [moduleDetails, setModuleDetails] = useState({});
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [showBreakdown, setShowBreakdown] = useState(false);


  const ConfirmRadioList = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];

  // Inputs the shown estimate was computed from — captured when the request is sent, not when it returns
  const estimateInputsRef = useRef<string>(getEstimateInputs(projectSetup));

  const persistEstimateToCache = (data: { quickplantAnalysis: quickplantAnalysisType, projectSummary: ProjectSummaryType, selectedOption: string }) => {
    const projectId = selected_project?.projectid || sessionStorage.getItem("projectid");
    if (!projectId) return;
    sessionStorage.setItem(getEstimateCacheKey(projectId), JSON.stringify({ ...data, inputs: estimateInputsRef.current }));
  };

  // useEffect(() => {
  //   const initAnalysis = async () => {
  //     // SCENARIO: Component mounted, but data is already in Redux and no changes were made
  //     const hasData = quickplantAnalysis?.electricityGenerated2;

  //     if (hasData && !projectSetupUpdated) {
  //       console.log("Optimization: Using cached Redux data for Solar Summary");
  //       return; 
  //     }

  //     if (projectSetup.sanctionload > 0) {
  //       setIsLoading?.(true);
  //       await getGenerationData();
  //       setIsLoading?.(false);
  //     }
  //   };

  //   initAnalysis();
  // }, [projectSetupUpdated]); // Only re-run if the parent signals a change


  // Existing Logic: Project Capacity Calculation
  useEffect(() => {
    const calculatePlantCapacity = async () => {
      if (!selected_project?.sanctionload || selected_project?.sanctionload === 0 || isCompleted) return;
      // const data = await fetchModuleInverter(selected_project?.sanctionload);
      // if (data) {
      // debugger
      if (true) {
        // setModuleDetails(data.module);
        // const module = data.module, moduleArea = (module.length * module.width), modulePower = module.stc;
        // const module = defaultModuleObject;
        // const moduleArea = (module.length * module.width), modulePower = module.stc;
        // const moduleNo = (selected_project?.useablearea ?? 0) / moduleArea;
        // const calculatedPlantCapacity = "" + ((moduleNo * modulePower) / 1000).toFixed(0);
        // console.log(" calculatedPlantCapacity data     -->>>  ",calculatedPlantCapacity)
        // dispatch(setPlantCapacity(parseInt(calculatedPlantCapacity)));
        dispatch(setPlantCapacity(convertACtoDC(projectSetup?.sanctionload) ?? 0));
      }
    };

    if (projectSetupUpdated.current) {
      calculatePlantCapacity();
    }
  }, [defaultModuleObject, selected_project?.useablearea]);
  // }, [selected_project?.useablearea, selected_project?.sanctionload, dispatch]);

  // Existing Logic: Data Fetching
  // useEffect(() => {
  //   if (sanctionload && sanctionload > 0) {

  //     if (selected_project && selected_project.iscompleted ) {
  //       bindQuickPlantData(selected_project);
  //     } else if(projectSetupUpdated.current) {
  //       // getGenerationData(ondFiles);
  //       getGenerationData();
  //     }
  //   }
  // }, []);

  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (hasFetchedRef.current) return; // ← guard against double-call

    // Restore a previously computed estimate (cost/generation/finance + the Yes/No choice)
    // so a page refresh doesn't lose it and force a needless re-fetch.
    const projectId = selected_project?.projectid || sessionStorage.getItem("projectid");
    const cachedRaw = projectId ? sessionStorage.getItem(getEstimateCacheKey(projectId)) : null;
    if (cachedRaw) {
      try {
        const cached = JSON.parse(cachedRaw);
        // Load / electricity rate / location / area changed since this estimate → fetch a fresh one
        if (cached?.inputs !== getEstimateInputs(projectSetup)) {
          sessionStorage.removeItem(getEstimateCacheKey(projectId!));
        } else if (cached?.quickplantAnalysis && cached?.projectSummary) {
          hasFetchedRef.current = true;
          dispatch(setFormQuickPlantAnalysisData(cached.quickplantAnalysis));
          dispatch(setFromProjectSummeryData(cached.projectSummary));
          if (cached.selectedOption) dispatch(setSelectedOption(cached.selectedOption));
          return;
        }
      } catch {
        sessionStorage.removeItem(getEstimateCacheKey(projectId!));
      }
    }

    if (sanctionload && sanctionload > 0) {
      if (selected_project && selected_project.iscompleted) {
        hasFetchedRef.current = true;
        bindQuickPlantData(selected_project);
      } else {
        // No estimate for the current inputs (a matching cache returned above) → always fetch
        hasFetchedRef.current = true;
        getGenerationData();
      }
    }
  }, []);

  // Keep the cached estimate in sync so it survives a refresh at any point in this flow.
  useEffect(() => {
    if (!quickplantAnalysis?.electricityGenerated2) return;
    persistEstimateToCache({ quickplantAnalysis, projectSummary, selectedOption });
  }, [quickplantAnalysis, projectSummary, selectedOption]);

  const bindQuickPlantData = async (projectDetails: ProjectTy) => {
    setIsLoading?.(true);
    try {
      const updatedQuickProject = {
        environmentalImpact: { carbonFootPrint: projectDetails?.carbonemission, treesPlanted: projectDetails?.totaltreesplanted },
        costbracket: projectDetails!.projectcost,
        electricityGenerated: projectDetails?.yearlygenusablearea,
        electricityGenerated2: projectDetails?.yearlygensanctioned,
      } as quickplantAnalysisType;
      const updatedProjectSummaryProject: ProjectSummaryType = {
        financial: {
          montlyFinancialSaving: parseFloat(projectDetails?.monthlyfinancialsavings!),
          // yearlyelectricbill isn't saved on most projects; the yearly saving is 12x the saved monthly one
          yearlyFinancialSaving: projectDetails?.yearlyelectricbill || (parseFloat(projectDetails?.monthlyfinancialsavings!) || 0) * 12,
          totalTrees: parseFloat(projectDetails?.totaltreesplanted!),
          netsavings: projectDetails?.netsavings!,
          totalCarbonfootprint: parseFloat(projectDetails?.carbonemission!),
        },
        degradation: {
          irr: parseFloat(projectDetails?.savingirr!),
          savingperiod: parseFloat(projectDetails?.savingperiod!)
        }
      };
      dispatch(setFormQuickPlantAnalysisData(updatedQuickProject));
      dispatch(setFromProjectSummeryData(updatedProjectSummaryProject));
    } finally {
      setIsLoading?.(false);
    }
  };

  const getGenerationData = async (data?: FileUplad) => {
    setIsLoading?.(true);
    if (sanctionload === 0) {
      toast.error('Project sanction load is 0');
      return;
    }
    try {
      const lati = selected_project ? selected_project.lat : lat ? lat : globalLayers.latitude;
      const longi = selected_project ? selected_project.lng : lng ? lng : globalLayers.longitude;
      const countryNameResponse = await fetchCountryNamefromLatLng(lati ?? 0, longi ?? 0);

      let newObj = { data, module: moduleDetails, totalSanctionLoad: +(selected_project?.plantcapacity ?? 0), loadVal: true, lat, lng, india: countryNameResponse?.toUpperCase() === "INDIA" };

      estimateInputsRef.current = getEstimateInputs(projectSetup);
      // Load just saved from the form; fall back to the saved project
      await dispatch(generationdegradationwithfinance2({ ...newObj, totalSanctionLoad: +(sanctionload || selected_project?.sanctionload || 0), electricityrate: +currencyConverter(user.country_mstr, electricityrate, true, true), loadVal: true, totalarea: useablearea }));
      // await dispatch(generationdegradationwithfinance({ ...newObj, electricityrate: +currencyConverter(user.country_mstr, electricityrate, true, true), loadVal: false, totalarea: useablearea }));

      projectSetupUpdated.current = false;
    } catch (err: any) {
      setSiteAnalysisFailMsg?.(true);
      console.error("Analysis failed. Please check site parameters.");
    } finally {
      setTimeout(() => setIsLoading?.(false), 4500);
      // setIsLoading?.(false);
    }
  };

  const handleMouseEnter = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setShowBreakdown(true);
  };

  const handleMouseLeave = () => {
    timerRef.current = setTimeout(() => setShowBreakdown(false), 150);
  };

  // Helper values for UI
  const annualGen = projectSummary?.financial?.yearlyFinancialSaving ?? 0;
  const payback = projectSummary?.degradation?.savingperiod ?? 0;
  const totalSavings = ((projectSummary?.financial?.montlyFinancialSaving ?? 0) * 12) * 25;
  const currencySymbol = getCurrencyLabel(user.country_mstr);


  const handleChooseInstallationMode = async () => {
    {
      if (selected_project?.installationmode) {
        toast.info("An order has already been placed for this project.", { toastId: "", autoClose: 7000 });
        return;
      };

      openViewProfileModal?.(null)
      dispatch(setModalHeaderFooter({ title: "How would you like to install your solar system?", btnTxt: "", secondaryBtnTxt: "", modalid: "finalproject", isheader: true }));
    };
  };

  // "Rate Us" stars (optional); saved with Proceed
  const [platformRating, setPlatformRating] = useState(0);
  // Own loading state: setIsLoading isn't passed by every parent, so it can't be relied on to disable Proceed
  const [proceeding, setProceeding] = useState(false);
  const proceedingRef = useRef(false);

  const handleProceedWithoutInstallation = async () => {
    // Set synchronously so a double click can't save twice before React re-renders
    if (proceedingRef.current) return;
    proceedingRef.current = true;
    setProceeding(true);
    setIsLoading?.(true);
    let ratingSaved = true;
    try {
      persistEstimateToCache({ quickplantAnalysis, projectSummary, selectedOption });
      // Persist the computed cost/generation figures onto the project record itself (without
      // marking iscompleted), so "Estimated system cost" is populated from the backend on
      // reload even though the user chose "No" and never completes an order.
      if (selected_project?.projectid) {
        await saveProjectDetails?.(selected_project.projectid);
      }
      if (platformRating) {
        ratingSaved = await submitPvnxtRating(platformRating);
      }
    } finally {
      proceedingRef.current = false;
      setProceeding(false);
      setIsLoading?.(false);
    }
    // A failed rating keeps the modal open (with the error toast) so Proceed can be retried
    if (ratingSaved) openViewProfileModal?.(null);
  };

  const [mode, setMode] = useState(false)

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = event.target

    if (name === "No") {
      dispatch(setSelectedOption(name))
      // dispatch(setSubsequentOption(""))
    } else {
      dispatch(setSelectedOption(name))
    }
  };

  console.log(projectSummary)

  return (
    <> {(selected_project?.plant_ac_capacity ?? 0) > 0 &&
      (
        <div className="fixed bottom-7 right-2 z-[9998]">
          <div className="bg-white rounded-2xl shadow-2xl w-[380px] p-4 relative">
            {/* Header */}
            <div className="flex items-center justify-between mb-3">
              <div>
                <h2 className="text-sm font-semibold text-gray-900">pvNxt summary</h2>
                <p className="text-[10px] text-gray-400 mt-0.5">Based on your roof size, we’ve automatically selected the best-matching solar panels and equipment for you. Here is your estimated system size and savings.</p>
              </div>
              {/* <button
                onClick={() => {}}
                className="text-gray-400 hover:text-gray-700 relative flex items-center justify-center"
              >
                <span className="absolute inline-flex h-5 w-5 rounded-full bg-gray-300 opacity-75 animate-ping" />
                <span className="relative z-10"><IconClose /></span>
              </button> */}
            </div>

            {/* Inverter + Module selected */}
            <div className="grid grid-cols-2 gap-2 mb-3">
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-2">
                <p className="text-[9px] text-gray-400  tracking-wide mb-0.5">Plant AC load</p>
                <p className="text-xs font-semibold text-gray-800 truncate">{(selected_project?.plant_ac_capacity)?.toFixed(2) || "--"} kW</p>
              </div>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-2">
                <p className="text-[9px] text-gray-400  tracking-wide mb-0.5">Plant DC load</p>
                <p className="text-xs font-semibold text-gray-800 truncate">{(selected_project?.plant_dc_capacity)?.toFixed(2) || "--"} kWp</p>
              </div>

             <div className="col-span-2 mt-2 flex text-[14px] text-red-500">
                <span className="font-medium whitespace-nowrap mr-1">
                  Note:
                </span>
                <span>
                  The system is sized to your connected load. Final capacity will be confirmed after detailed design.
                </span>
              </div>
            </div>

            <div className="w-full max-w-sm rounded-md border border-gray-200 bg-white p-3">
              <h4 className="mb-2 text-xs font-semibold text-gray-700">
                Financial & Environmental Overview
              </h4>

              <div className="space-y-1 text-[11px]">
                <div className="flex justify-between">
                  <span className="text-gray-500">Monthly Saving</span>
                  <span className="font-medium text-gray-900">~ {formatCompactNumber((Number(projectSummary?.financial?.montlyFinancialSaving ?? 0) / (country_mstr?.currencyrate ?? 1)), country_mstr?.alpha2code ?? "--")} {getCurrencyLabel(country_mstr)}</span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-500">Yearly Saving</span>
                  <span className="font-medium text-gray-900">~ {formatCompactNumber((Number(projectSummary?.financial?.yearlyFinancialSaving || (projectSummary?.financial?.montlyFinancialSaving ?? 0) * 12) / (country_mstr?.currencyrate ?? 1)), country_mstr?.alpha2code ?? "--")} {getCurrencyLabel(country_mstr)}</span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-500">IRR</span>
                  <span className="font-medium text-gray-900">~ {formatNumber2(projectSummary?.degradation?.irr)}%</span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-500">Trees Planted </span>
                  <span className="font-medium text-gray-900">~ {Math.round(projectSummary?.financial?.totalTrees ?? 0)}</span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-500">Annual CO₂ emissions avoided</span>
                  <span className="font-medium text-gray-900">~ {formatNumber2(projectSummary?.financial?.totalCarbonfootprint ?? 0)} tons</span>
                </div>
              </div>
            </div>

            {/* Divider */}
            {/* <div className="border-t border-gray-100 mb-3" /> */}

            {/* Calculated Stats */}
            {/* <div className="grid grid-cols-3 gap-2">
             
            </div>

            <p className="text-[9px] text-gray-400 text-center mt-3">
              Updates automatically when inverter or module changes.
            </p> */}
          </div>
        </div>
      )
    }
      <div className="max-w-[23rem]">
        {/* Header Section */}
        <div className="mb-4">
          <div className="mt-3">
            <h3 className="heading-14-roboto">Your solar estimate is ready</h3>
            <p className="text-12-roboto mt-1">
              Based on your roof size and location, see your system size, savings, and choose how you want to install.
            </p>
          </div>
        </div>

        {/* System Size Card */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex  gap-3">
            <div className="pt-1">
              <SolarPowerIcon />
            </div>
            <div>
              <p className="heading-14-roboto-normal">Plant Size (AC) </p>
              <h4 className="text-xl font-semibold text-[rgba(17,63,74,1)]">
                {`${sanctionload ?? 0} kW`}
              </h4>
            </div>
          </div>
          {/* <button className="text-[12px] font-Roboto text-[rgba(0,0,0,1)] underline decoration-gray-400 cursor-default">
          See Full Proposal
        </button> */}
        </div>

        <hr className="border-gray-400 mb-3" />

        {/* Stats List */}
        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <p className="heading-12-inter flex items-center relative">Total savings in 25 years <span className="cursor-pointer ml-1" data-tooltip-id="financialsavingstooltip"><IconInfo1 /></span></p>
            <span className="heading-14-inter-info">
              {/* { `${isLoading ? '...loading' : `~ ${formatCompactNumber(parseFloat(String(toFixed((((projectSummary?.financial?.montlyFinancialSaving??0) * 12) * 25 / user.country_mstr?.currencyrate!)))),user?.country_mstr?.alpha2code) || "--"} ${getCurrencyLabel(country_mstr)} `} `} */}
              {`${isLoading || generationLoading ? '...loading' : `~ ${formatCompactNumber(parseFloat(String(toFixed(((projectSummary?.degradation?.netsavings ? projectSummary?.degradation?.netsavings ?? 0 : selected_project?.netsavings ?? 0) / user.country_mstr?.currencyrate!)))), user?.country_mstr?.alpha2code) || "--"} ${getCurrencyLabel(country_mstr)} `} `}
            </span>
          </div>

          <div className="flex justify-between items-center">
            <p className="heading-12-inter flex items-center relative">Annual energy generation <span className="cursor-pointer ml-1" data-tooltip-id="totalgenerationtooltip"><IconInfo1 /></span></p>
            <span className="heading-14-inter-info">
              {isLoading || generationLoading ? `...loading` : `${quickplantAnalysis.electricityGenerated2 ? "~ " + formatEnergy(+parseFloat(quickplantAnalysis.electricityGenerated2)?.toFixed(2), true) : "-- kWh/yr"}`}       </span>
          </div>

          <div className="flex justify-between items-center">
            <span className="heading-12-inter">Payback period</span>
            <span className="heading-14-inter-info">
              {`${isLoading || generationLoading ? "...loading" : `~ ${(isNaN(projectSummary?.degradation?.savingperiod ?? 0) ? 0 : projectSummary?.degradation?.savingperiod ?? 0)} years`}`} </span>
          </div>

          <hr className="border-gray-400 mb-4" />

          <div className={` flex justify-between items-center ${isCompleted ? " " : " pb-3 "}`}>
            <div>
              <p className="heading-14-inter flex items-center relative leading-none mt-2" >Total project cost
              </p>
              <span className="heading-12-inter-normal-sub ">All inclusive</span>
            </div>
            <span className="heading-14-inter-info">
              {`${isLoading || generationLoading ? '...loading' : `~ ${(selected_project?.consumer_subprojectstatus ?? 0) < 3 ? formatCompactNumber((parseFloat(quickplantAnalysis?.costbracket) / user.country_mstr?.currencyrate!), user.country_mstr?.alpha2code!)
                : formatCompactNumber((parseFloat(selected_project?.projectcost ?? "0") / user.country_mstr?.currencyrate!), user?.country_mstr?.alpha2code) || "--"} ${getCurrencyLabel(country_mstr)} `} `}
            </span>
          </div>

        </div>


        {/* Choose installation mode  */}

        {!isCompleted && <hr className="border-gray-400 mb-5" />}

        <div className={` ${isCompleted ? " hidden " : ""} `}>
          {/* Confirm option type  */}
          <div>
            <div className="main-box2 w-[26rem] p-0">
              <label className="heading-12-roboto normal-case">Let us know if you would like to reduce your electricity bills.</label>
              <div className="input-main2">
                <InputRadio disabled={isLoading || generationLoading} options={ConfirmRadioList} name="userType" onChange={handleRadioChange} value={selectedOption} />
              </div>
            </div>
          </div>
          <div>
            <div className=" mb-3" />
            <div className={`${selectedOption === "No" ? "" : "hidden"}`}>
              <div className="heading-12-roboto normal-case">
                How was your experience with {PVNXT_MODE} Platform?
              </div>
              <StarRating value={platformRating} onChange={setPlatformRating} disabled={proceeding} />
              <div className="mb-2"></div>
              {<Button className={`btn btn-sm-primary w-full mt-2`} disabled={proceeding} type="button" isLoading={isLoading || generationLoading || proceeding} onClick={handleProceedWithoutInstallation} ><span className="flex gap-2"> {" Proceed"} </span></Button>}
            </div>
            {selectedOption === "Yes" && <Button className={`btn btn-sm-primary w-full`} disabled={false} type="button" isLoading={isLoading || generationLoading} onClick={() => handleChooseInstallationMode()} ><span className="flex gap-2"> {" Choose Installation Option"} {<BackBoxIcon rotate90 />} </span></Button>}

          </div>
        </div>

      </div>
    </>
  );
};

export default memo(SolarSummary);